import { FC } from 'react';
import { EspAccount } from 'modules/graphql/types';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { getEditAccountSchema } from './schemas';
import { createInitialValues } from './utils';

type AccountFormProviderProps = {
  espAccount: EspAccount;
};

export const EditAccountFormProvider: FC<React.PropsWithChildren<AccountFormProviderProps>> = ({
  children,
  espAccount,
}) => {
  /** Type coercions to be updated as providers are added */
  const schema = getEditAccountSchema(espAccount);
  const defaultValues = createInitialValues(espAccount);

  type FormSchemaType = Required<z.infer<typeof schema>>;

  const methods = useForm<FormSchemaType>({
    defaultValues,
    mode: 'onChange',
    resolver: zodResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
